<template>
  <v-app >
    <AppBar v-if="!loginPage" />
    <Drawer v-if="!loginPage" />
    <v-content>
      <router-view />
    </v-content>

    <v-snackbar v-model="snackbar.active" :timeout="snackbar.timeout">
      <v-row>
        <p style="margin: auto 1vw;" v-text="snackbar.text" />
        <v-spacer />
        <v-btn :color="snackbar.color" style="margin: auto;" @click="snackbar.active = false">{{ $t('button.close') }}</v-btn>
      </v-row>
    </v-snackbar>
  </v-app>
</template>

<script>
import AppBar from './components/core/AppBar'
import Drawer from './components/core/Drawer'
import { mapState } from 'vuex'

export default {
  name: 'App',

  components: {
    AppBar,
    Drawer
  },

  data: () => ({
    snackbar: {
      active: false,
      text: '',
      timeout: 5000,
      color: ''
    }
  }),

  computed: { ...mapState(['loginPage']) },

  beforeCreate () { this.$versionable.update() },
  // beforeUpdate () { this.$versionable.update() },

  created () {
    this.$message.warning = (text = '', timeout = 5000) => {
      console.warn(text)
      this.snackbar.active = true
      this.snackbar.text = text
      this.snackbar.timeout = timeout
      this.snackbar.color = '#F57C00'
    }
    this.$message.success = (text = '', timeout = 5000) => {
      this.snackbar.active = true
      this.snackbar.text = text
      this.snackbar.timeout = timeout
      this.snackbar.color = 'primary'
    }
    this.$message.error = (text = '', timeout = 5000) => {
      console.error(text)
      this.snackbar.active = true
      this.snackbar.text = text
      this.snackbar.timeout = timeout
      this.snackbar.color = '#D32F2F'
    }
  },

  watch: {
    '$i18n.locale': {
      immediate: true,
      handler () {
        this.$vuetify.lang.current = this.$t('vuetify_language')
      }
    }
  }

}
</script>
